import React, { useState } from "react";

import { pageTitle } from "../PageTitle";
import overlayimg from "./../../assets/images/resource/uipath.jpg";
import HeaderOne from "../Header/HeaderOne";

import FooterOne from "../Footer/FooterOne";
import aiOperations from "./../../assets/images/banner/rpa-banner.png";
import { Link, useLocation } from "react-router-dom";


const AI_Operations = () => {
  pageTitle("RPA in Operations");

  const [formData, setFormData] = useState({
    name: "",

    email: "",

    subject: "",

    phone: "",

    message: "",
  });

  const location = useLocation();

  const pathnames = location.pathname.split("/").filter((x) => x);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Your logic to handle form submission goes here

    console.log("Form submitted:", formData);

    // Clear the form fields after submission if needed

    setFormData({
      name: "",

      email: "",

      subject: "",

      phone: "",

      message: "",
    });
  };

  const servicesData = [
    { id: 1, title: "AI_Accounting_Finance", slug: "/AI_Accounting_Finance" },
    { id: 2, title: "AI-Audit-Compliance", slug: "/AI-Audit-Compliance" },
    { id: 3, title: "AI-Human-Resources", slug: "/AI-Human-Resources" },
    { id: 4, title: "AI-Operations", slug: "/AI-Operations" },
  ];

  const renderServices = () => {
    return servicesData.map((service) => (
      <li
        key={service.id}
        className={service.slug === "/content-marketing" ? "active" : ""}
      >
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));
  };

  return (
    <>
      <HeaderOne></HeaderOne>
      <div className="ai-overlay-wrapper">
        <img src={aiOperations} alt="AI Operations" className="main" />

        <div className="ai-overlay">
          <img
                                          src={overlayimg}
                                          alt="RPA Icon"
                                          className="ai-overlay-corner-img"
                                        />
          <h2>RPA For Operations</h2>
        </div>
      </div>

      {/* RPA Accounting Impact Section */}
      <section className="rpa-af-section">
        <div className="container">
          {/* FULL WIDTH INTRO */}
          <div className="row">
            <div className="col-12">
              <div className="rpa-af-content">
                <h2 className="rpa-af-title">RPA for Operations</h2>

                <p className="rpa-af-desc">
                  <span className="rpa-af-dropcap">T</span>
                  oday <span className="rpa-af-highlight">Operations</span>{" "}
                  various businesses are digitizing vital parts of their
                  operations, which entails failing fast through an agile work
                  environment. Perhaps the most important element in producing
                  operational efficiency is empowering your workforce through
                  innovative ideologies, and assessing aspects of your
                  operational processes for automation candidates.
                </p>
              </div>
            </div>
          </div>

          {/* TWO COLUMN SECTION */}
          <div className="row align-items-center mt-4">
            {/* LEFT CONTENT */}
            <div className="col-lg-8">
              <h3 className="rpa-af-subtitle">What’s the Impact?</h3>

              <p className="rpa-af-desc">
                The impact of Robotic Process Automation (RPA) on business
                operations is virtually unlimited, expanding its dynamic reach
                between various industries like food service and manufacturing.
                Operations managers can manipulate RPA to create workarounds,
                circumvent processes, and re-engineer system work. RPA can also
                be used as a tool to empower staff to identify candidates for
                automation and try new ideas to fix perennial problems.{" "}
              </p>
              <p className="rpa-af-desc mt-3">
                Domino’s Pizza is an example of an organization that used
                automation technologies to increase the experience of both
                back-office employees and customers. With new efficiencies like
                in-store kiosks, real-time order tracking, and virtual order
                assistants (DOM), the customer experience was optimized while
                back-of-house operations were streamlined.{" "}
              </p>
            </div>

            {/* RIGHT CARD */}
            <div className="col-lg-4">
              <div className="rpa-af-stats-card">
                <div className="rpa-af-stats-row">
                  <div className="rpa-af-stat">
                    <div>
                      <h4>87%</h4>
                      <p>Time Saved Per Process</p>
                    </div>
                  </div>
                </div>

                <p className="rpa-af-case-text">
                  One of our restaurant groups automated their weekly inventory
                  audit process as well as applicable sales discounts for the
                  day on their variety of products.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* RPA Use Cases Section */}
      <section className="rpa-uc-section">
        <div className="container">
          <div className="row align-items-center">
            {/* LEFT GRADIENT CARD */}
            <div className="col-lg-4">
              <div className="rpa-uc-card">
                <div className="rpa-uc-card-icon">
                  <i className="fa-solid fa-diagram-project"></i>
                </div>

                <h3 className="rpa-uc-card-title">
                  Digitizing Operational Efficiencies
                </h3>

                <ul className="rpa-uc-card-list">
                  <li>Ignite innovation, reduce stagnancy</li>
                  <li>Enhance customer experience</li>
                  <li>Reduce operational costs</li>
                  <li>Digitize time-sensitive processes</li>
                  <li>Introduce hyperautomation</li>
                </ul>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-8">
              <div className="rpa-uc-content">
                <h2 className="rpa-uc-heading">
                  Key RPA Use Cases in Operations
                </h2>

                <ul className="rpa-uc-list">
                  <li>
                    <strong>Customer Ordering:</strong> Customers and vendors
                    can place/track orders through self-service help options and
                    unique credentials.
                  </li>

                  <li>
                    <strong>Manufacturing:</strong> Manufacturers must juggle
                    labor and various time-intensive processes such as
                    inventory, procurement and customer communication, all which
                    can be automated.
                  </li>

                  <li>
                    <strong>Sales and Orders:</strong> Sales operations
                    encompass tasks like CRM data entries and ERP accounting
                    updates, both candidates for automation.
                  </li>

                  <li>
                    <strong>Food Service:</strong>Restaurants are constantly met
                    with the pressure to innovate front and back-of-house
                    operations to ensure their product is desired in the right
                    medium.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterOne></FooterOne>
    </>
  );
};

export default AI_Operations;
